module.exports = __webpack_public_path__ + "assets/img/map.94243446.png";